module.exports = __webpack_public_path__ + "static/media/6.9704ab2d.jpg";